export default function isDesktopFromWebpackOrFromSSRUtil () {
  return (
    DESKTOP_SCREEN ||
    (
      SERVER && global.DESKTOP_SCREEN
    )
  )
}
